import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'umss-menu-group-label',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './menu-group-label.component.html',
  styleUrl: './menu-group-label.component.scss'
})
export class UmssMenuGroupLabelComponent {
  @HostBinding('style.display') display = 'contents';

  /** Content props */
  @Input() text: string = '';
  @Input() label: string = '';

  /** Variant props */
  @Input() size: 'Small' | 'Regular' | 'Large' = 'Regular';
  @Input() variant: 'Default' | 'Compact' | 'Indented' = 'Default';

  /** State props */
  @Input() disabled: boolean = false;
  @Input() indented: boolean = false;

  /** Computed properties */
  get displayText(): string {
    return this.text || this.label;
  }

  get isIndented(): boolean {
    return this.indented || this.variant === 'Indented';
  }
}
